import { render } from "./loginPage.vue?vue&type=template&id=54fb7cde&scoped=true"
import script from "./loginPage.vue?vue&type=script&lang=js"
export * from "./loginPage.vue?vue&type=script&lang=js"

import "./loginPage.vue?vue&type=style&index=0&id=54fb7cde&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54fb7cde"]])

export default __exports__